import { z } from 'zod';
export const signatureDetailsSchema = z
    .object({
    patientRefusedToSign: z.boolean().nullish(),
    representativeSigned: z.boolean().nullish(),
    authorizedRepName: z.string().nullish(),
    signatureValue: z.string().nullish(),
    signatureMethod: z.string().nullish(),
    unableToSignReasons: z.array(z.string()).nullish(),
    unableToSignOther: z.string().nullish(),
    qprAuthority: z.string().nullish(),
})
    .default({});
export const applySignatureRefinement = (ctx, data, options = {}) => {
    const { signatureField = 'patientSigned', signatureMessage = 'Patient signature is required', requireFullDate = false } = options;
    const { signatureDetails } = data;
    if (!signatureDetails.patientRefusedToSign) {
        if (data[signatureField] !== true) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                path: [signatureField],
                message: signatureMessage,
            });
        }
        const dateMissing = requireFullDate ? !data.signedDate || data.signedDate.length < 10 : !data.signedDate;
        if (dateMissing) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                path: ['signedDate'],
                message: 'Signature date is required',
            });
        }
    }
    if (signatureDetails.representativeSigned && !signatureDetails.authorizedRepName?.trim()) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            path: ['signatureDetails', 'authorizedRepName'],
            message: 'Authorized representative name is required',
        });
    }
};
